export default {"src":"/_next/static/media/logo-fortunadado.150cdacc.svg","height":90,"width":90,"blurWidth":0,"blurHeight":0};